import { CalendarMonth, Description, Group, HomeRepairService, LocationOn, Person, Summarize } from "@mui/icons-material";
import { JobApproved } from "../../../jobs/jobs-list/jobs-layout/components/Approved/JobApproved";
import { QuoteTable } from "../../../quotes/QuotesTable/QuoteTable";
import { JobBasicList } from "../../../quotes/quote-create-stepper/basic-quote/components/JobBasicList";
import { ScopeOfWorkView } from "../../../shared/components/features/scope-of-work/view/ScopeOfWorkView";
import { JobCreateSummary } from "../JobCreateSummary";
import { EventSchedulerView } from "../../../shared/components/features/event-scheduler/view/EventSchedulerView";
import { QuoteModeSelectorStep } from "../components/QuoteModeSelectorStep";
import { SelectClientAddressStep } from "../components/SelectClientAddressStep";
import { SelectClientStep } from "../components/SelectClientStep";

export const JOB_CREATE_STEPS = [
  {
    key: "selectClient",
    name: "Select a Client",
    description: "Select client first.",
    icon: <Person />,
    validate: "client",
    when: ({ withQuoteService, clientUidSelected, skipClientStep }) => !skipClientStep && !withQuoteService && !clientUidSelected,
    isSubWizard: false,
    render: () => <SelectClientStep isUpdateJob={false} jobId={null} />,
  },
  {
    key: "selectClientAddress",
    name: "Select address",
    description: "Choose the address for this job.",
    icon: <LocationOn />,
    validate: "client-address",
    when: ({ needsAddressChoice, skipClientStep, withQuoteService }) => !skipClientStep && !withQuoteService && needsAddressChoice,
    isSubWizard: false,
    render: () => <SelectClientAddressStep />,
  },
  {
    key: "quoteMode",
    name: "Select Service Mode",
    description: "Choose Basic or Advanced.",
    icon: <HomeRepairService />,
    validate: "quote-mode",
    when: ({ withQuoteService }) => !withQuoteService,
    isSubWizard: false,
    render: () => <QuoteModeSelectorStep />,
  },
  {
    key: "scopeOfWork",
    name: "Create Service",
    description: "Create the service details.",
    icon: <HomeRepairService />,
    validate: "scope-of-work",
    when: ({ withQuoteService }) => !withQuoteService,
    isSubWizard: true,
    hiddenInStepper: false,
    render: ({ isBasic, onStateScopeOfWorkChange, scopeOfWorkState, ref }) => {
      return isBasic ? (
        <JobBasicList
          onlyOneService={isBasic}
          onPayloadChange={onStateScopeOfWorkChange}
          initialRows={Array.isArray(scopeOfWorkState) ? scopeOfWorkState : undefined}
        />
      ) : (
        <ScopeOfWorkView ref={ref} onStateChange={onStateScopeOfWorkChange} initialPayload={scopeOfWorkState} />
      );
    },
  },
  {
    key: "schedule",
    name: "Schedule",
    description: "Choose a time or explicitly schedule later.",
    icon: <CalendarMonth />,
    validate: "time",
    when: ({ withQuoteService }) => !withQuoteService,
    isSubWizard: false,
    render: ({ onStateEventSchedulerChange, eventSchedulerState }) => (
      <EventSchedulerView
        existingPayload={eventSchedulerState?.eventPreferences?.eventConfig ?? null}
        onPayloadChange={onStateEventSchedulerChange}
        disableJsonPayload
      />
    ),
  },
  {
    key: "selectQuote",
    name: "Select a Quote",
    description: "Choose a quote to create the job.",
    icon: <Description />,
    validate: "quote",
    when: ({ withQuoteService }) => withQuoteService,
    isSubWizard: false,
    render: () => <QuoteTable enableSelection onlyAccepted />,
  },
  {
    key: "workforce",
    name: "Select Workforce",
    description: "Choose the default workforce for this job.",
    icon: <Group />,
    validate: "workforce",
    when: () => true,
    isSubWizard: false,
    render: () => <JobApproved data={null} mode="create" />,
  },
  {
    key: "summary",
    name: "Summary",
    description: "Review all details before creating the job.",
    icon: <Summarize />,
    validate: "none",
    when: () => true,
    isSubWizard: false,
    hiddenInStepper: false,
    render: ({ goToStepByKey, isUpdateJob, clientUidSelected }) => (
      <JobCreateSummary goToStepByKey={goToStepByKey} isUpdateJob={isUpdateJob} clientLocked={Boolean(clientUidSelected)} />
    ),
  },
];
